import Box from "@mui/material/Box";

export type Stage = "company" | "contract" | "signature" | "payment";
export type StageDurationBarProps = { stages: Record<Stage, number | null>; maxMin?: number; ariaLabel: string };

// Drill nível plantão: Empresa → Contrato → Assinatura → Pagamento.
export const STAGE_COLORS: Record<Stage, string> = { company: "#0b84d6", contract: "#6b5bd2", signature: "#9a57d6", payment: "#e8710a" };
export const STAGE_LABELS: Record<Stage, string> = { company: "Empresa", contract: "Contrato", signature: "Assinatura", payment: "Pagamento" };
const ORDER: Stage[] = ["company", "contract", "signature", "payment"];
const DEFAULT_MAX_MIN = 5760; // 96 h
const pct = (n: number) => `${Math.round(n * 10000) / 100}%`;

// Segmentos em escala fixa (0–maxMin); a soma além da escala é cortada em 100%. CSS puro, sem recharts.
export function StageDurationBar({ stages, maxMin = DEFAULT_MAX_MIN, ariaLabel }: StageDurationBarProps) {
  let used = 0;
  return (
    <Box role="img" aria-label={ariaLabel} sx={{ display: "flex", height: "12px", bgcolor: "#eef1f4", borderRadius: "3px", overflow: "hidden" }}>
      {ORDER.map((s) => {
        const min = stages[s];
        if (min == null || min <= 0) return null;
        const share = Math.min(min / maxMin, 1 - used);
        used += share;
        return <Box key={s} data-testid={`stage-${s}`} title={`${STAGE_LABELS[s]}: ${min} min`} sx={{ width: pct(share), bgcolor: STAGE_COLORS[s] }} />;
      })}
    </Box>
  );
}
